export default __webpack_public_path__ + "static/media/9.2d14c9b1.png";